<script setup>
import { ref } from 'vue';
import { I18nT, useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import { ARROWS_AI_PLAN_SUPPORT_URL } from 'dashboard/helper/arrowsAiSupport';

const emit = defineEmits(['close']);
const { t } = useI18n();
const dialogRef = ref(null);

const contactSupport = () => {
  window.open(ARROWS_AI_PLAN_SUPPORT_URL, '_blank', 'noopener,noreferrer');
  dialogRef.value?.close();
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="t('ARROWS_AI.INBOXES.QUOTA_TITLE')"
    :confirm-button-label="t('ARROWS_AI.INBOXES.CONTACT_SUPPORT')"
    @confirm="contactSupport"
    @close="emit('close')"
  >
    <template #description>
      <I18nT
        keypath="ARROWS_AI.INBOXES.QUOTA_SUBTITLE"
        tag="p"
        class="mb-0 text-sm text-n-slate-11"
      >
        <template #support>
          <a
            :href="ARROWS_AI_PLAN_SUPPORT_URL"
            target="_blank"
            rel="noopener noreferrer"
            class="font-medium text-n-violet-11 hover:underline"
            @click="dialogRef?.close()"
          >
            {{ t('ARROWS_AI.INBOXES.CONTACT_SUPPORT') }}
          </a>
        </template>
      </I18nT>
    </template>
  </Dialog>
</template>
